import * as React from 'react';
import IPhotographer from './IPhotographer';
import { Translate } from '../../shared/LanguageService';
import { Button, ButtonToolbar } from 'react-bootstrap';
import ImpersonateButton from '../../components/ImpersonateButton';
import TelephoneLink from '../../components/common/TelephoneLink';
import EmailLink from '../../components/common/EmailLink';

interface PhotographerUserListRowProps {
    photographer: IPhotographer;
    key: number;
    edit: (id: number) => void;
    logs: (id: number) => void;
}

const PhotographersListRow = (props: PhotographerUserListRowProps) => {
    return (
        <tr>
            <td>{props.photographer.name}</td>
            <td>
                <EmailLink>{props.photographer.email}</EmailLink>
            </td>
            <td>
                <TelephoneLink>{props.photographer.phoneNumber}</TelephoneLink>
            </td>
            <td>
                {props.photographer.cubicasaStatus
                    ? Translate(props.photographer.cubicasaStatus.displayName)
                    : ''}
            </td>
            <td className="tools">
                <ButtonToolbar className="pull-right btn-group-sm">
                    <Button
                        onClick={() => {
                            props.edit(props.photographer.id);
                        }}
                        bsStyle="primary"
                    >
                        <i className="material-icons">edit</i>{' '}
                        {Translate('photographers/list/row/button-label/edit')}
                    </Button>
                    <Button onClick={() => props.logs(props.photographer.id)} bsStyle="default">
                        <i className="material-icons">list</i>{' '}
                        {Translate('photographers/list/row/button-label/logs')}
                    </Button>
                    <ImpersonateButton userId={props.photographer.id} />
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default PhotographersListRow;
